import { ProductDiscountType } from '../../types/Products/productDiscount';
import { request } from '../../utils/request';

export const updateProductDiscount = (
  discountId: number,
  updates: Partial<ProductDiscountType>,
  authToken: string
) =>
  request({
    method: 'PUT',
    url: `/products/discount/${discountId}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    formData: updates,
    onError: (err) => {
      throw err;
    },
  });
